module.exports = __webpack_public_path__ + "img/unitLogo.59400bca.png";